/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The DefaultApiResponse model module.
 * @module model/DefaultApiResponse
 * @version 1.0.0
 */
class DefaultApiResponse {
    /**
     * Constructs a new <code>DefaultApiResponse</code>.
     * @alias module:model/DefaultApiResponse
     */
    constructor() { 
        
        DefaultApiResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>DefaultApiResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DefaultApiResponse} obj Optional instance to populate.
     * @return {module:model/DefaultApiResponse} The populated <code>DefaultApiResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DefaultApiResponse();

            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
        }
        return obj;
    }


}

/**
 * Estado de la respuesta
 * @member {String} status
 */
DefaultApiResponse.prototype['status'] = undefined;






export default DefaultApiResponse;

